// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2rg-G","colCheckbox":"styles_colCheckbox__3ow0j"};